export type ExpoWebviewVersionResponse = {
  result: boolean;
  packageName: string | null;
  versionName: string | null;
};
